import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { AlertCount } from './alert.interface';
import { AlertService } from './alert.service';

const service = new AlertService();

export interface AlertState {
   alertCount?: AlertCount;
}

const AlertStore: Module<AlertState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_ALERT_COUNT(state, alertCount?: AlertCount) {
         state.alertCount = alertCount;
      },
   },
   actions: {
      async getAlerts(context, query?: LocationQuery) {
         const response = await service.getAlerts(query);
         return response;
      },
      async getAlertCount(context) {
         const response = await service.getAlertCount();
         context.commit('SET_ALERT_COUNT', response);
         return response;
      },
      async deleteAlert(context, alertId: number) {
         await service.deleteAlert(alertId);
      },
   },
};

export default AlertStore;
